/* CAF tracking bridge:
 * - Keeps AJAX cart flows observable for analytics tools
 * - Emits fallback add_to_cart and begin_checkout events
 * - Does not alter cart/checkout behavior
 */
(function () {
  'use strict';

  if (window.__cafTrackingBridgeInitialized) return;
  window.__cafTrackingBridgeInitialized = true;

  var cartSnapshot = null;
  var recentEventAt = Object.create(null);

  function nowMs() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function isRecent(key, ttlMs) {
    var now = nowMs();
    var last = recentEventAt[key] || 0;
    if (now - last < ttlMs) return true;
    recentEventAt[key] = now;
    return false;
  }

  function getShopCurrency() {
    var bodyCurrency = document.body && document.body.getAttribute('data-shop-currency');
    if (bodyCurrency) return bodyCurrency;

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }

    return 'USD';
  }

  function toMajorUnits(amount) {
    var cents = Number(amount || 0);
    if (!isFinite(cents)) return 0;
    return Math.round(cents) / 100;
  }

  function safeParseJson(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function normalizeItem(rawItem) {
    if (!rawItem || typeof rawItem !== 'object') return null;

    var variantId = rawItem.variant_id || rawItem.id || null;
    var productId = rawItem.product_id || null;
    var quantity = Number(rawItem.quantity || 1);
    if (!isFinite(quantity) || quantity <= 0) quantity = 1;

    var priceInCents = rawItem.final_price;
    if (priceInCents == null) priceInCents = rawItem.price;

    var item = {
      price: toMajorUnits(priceInCents),
      quantity: quantity,
    };

    if (productId || variantId) item.item_id = productId ? String(productId) : String(variantId);
    if (variantId) item.item_variant = String(variantId);
    if (rawItem.product_title || rawItem.title) item.item_name = rawItem.product_title || rawItem.title;
    if (rawItem.vendor) item.item_brand = rawItem.vendor;
    if (rawItem.product_type) item.item_category = rawItem.product_type;

    return item;
  }

  function ga4ItemsFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    var items = [];
    for (var i = 0; i < cart.items.length; i += 1) {
      var mapped = normalizeItem(cart.items[i]);
      if (mapped) items.push(mapped);
    }

    return items;
  }

  function clearAndPushDataLayer(eventPayload) {
    if (!window.dataLayer || !Array.isArray(window.dataLayer)) return;

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventPayload);
  }

  function trackAddToCart(rawLineItem) {
    var lineItem = rawLineItem && typeof rawLineItem === 'object' ? rawLineItem : null;
    if (!lineItem) return;

    var item = normalizeItem(lineItem);
    if (!item) return;

    var eventKey = 'add_to_cart:' + String(item.item_variant || item.item_id || '') + ':' + String(item.quantity);
    if (isRecent(eventKey, 500)) return;

    var currency = getShopCurrency();
    var value = Number((item.price * item.quantity).toFixed(2));

    document.dispatchEvent(
      new CustomEvent('caf:add_to_cart', {
        detail: {
          line_item: lineItem,
          currency: currency,
          value: value,
        },
      })
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        currency: currency,
        value: value,
        items: [item],
      });
    }

    if (typeof window.fbq === 'function') {
      var metaPayload = {
        content_type: 'product',
        value: value,
        currency: currency,
      };
      var contentId = item.item_variant || item.item_id;
      if (contentId) metaPayload.content_ids = [contentId];

      window.fbq('track', 'AddToCart', metaPayload);
    }

    clearAndPushDataLayer({
      event: 'add_to_cart',
      ecommerce: {
        currency: currency,
        value: value,
        items: [item],
      },
    });
  }

  function trackBeginCheckout() {
    if (isRecent('begin_checkout', 1200)) return;

    var currency = getShopCurrency();
    var payload = {
      currency: currency,
    };

    var items = ga4ItemsFromCart(cartSnapshot);
    if (items.length > 0) {
      payload.items = items;
      if (cartSnapshot && typeof cartSnapshot.total_price !== 'undefined') {
        payload.value = Number(toMajorUnits(cartSnapshot.total_price).toFixed(2));
      }
    }

    document.dispatchEvent(
      new CustomEvent('caf:begin_checkout', {
        detail: payload,
      })
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'begin_checkout', payload);
    }

    if (typeof window.fbq === 'function') {
      var metaPayload = {
        currency: currency,
      };

      if (typeof payload.value === 'number') metaPayload.value = payload.value;
      if (items.length > 0) metaPayload.num_items = items.length;

      window.fbq('track', 'InitiateCheckout', metaPayload);
    }

    clearAndPushDataLayer({
      event: 'begin_checkout',
      ecommerce: payload,
    });
  }

  function tryStoreCartSnapshotFromBody(responseText) {
    var parsed = safeParseJson(responseText);
    if (!parsed || typeof parsed !== 'object' || !Array.isArray(parsed.items)) return;
    cartSnapshot = parsed;
  }

  function normalizePathFromUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (_error) {
      return '';
    }
  }

  function handleNetworkResponse(url, status, responseText) {
    var path = normalizePathFromUrl(url);
    if (!path || status < 200 || status >= 300) return;

    if (path === '/cart/add.js') {
      var addResponse = safeParseJson(responseText);
      if (addResponse && Array.isArray(addResponse.items)) {
        for (var i = 0; i < addResponse.items.length; i += 1) {
          trackAddToCart(addResponse.items[i]);
        }
      } else if (Array.isArray(addResponse)) {
        for (var c = 0; c < addResponse.length; c += 1) {
          trackAddToCart(addResponse[c]);
        }
      } else if (addResponse) {
        trackAddToCart(addResponse);
      }
      return;
    }

    if (path === '/cart.js' || path === '/cart/change.js' || path === '/cart/update.js') {
      tryStoreCartSnapshotFromBody(responseText);
    }
  }

  function patchXhr() {
    if (!window.XMLHttpRequest) return;
    if (XMLHttpRequest.prototype.__cafTrackingPatched) return;

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cafTrackingUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (!this.__cafTrackingBound) {
        this.__cafTrackingBound = true;
        this.addEventListener('loadend', function () {
          handleNetworkResponse(this.__cafTrackingUrl, this.status, this.responseText);
        });
      }

      return nativeSend.apply(this, arguments);
    };

    XMLHttpRequest.prototype.__cafTrackingPatched = true;
  }

  function patchFetch() {
    if (typeof window.fetch !== 'function') return;
    if (window.__cafTrackingFetchPatched) return;

    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url ? input.url : '';

      return nativeFetch.call(this, input, init).then(function (response) {
        try {
          if (requestUrl && response && response.ok) {
            var path = normalizePathFromUrl(requestUrl);
            if (
              path === '/cart/add.js' ||
              path === '/cart.js' ||
              path === '/cart/change.js' ||
              path === '/cart/update.js'
            ) {
              response
                .clone()
                .text()
                .then(function (text) {
                  handleNetworkResponse(requestUrl, response.status, text);
                })
                .catch(function () {
                  // Ignore parsing/network clone errors.
                });
            }
          }
        } catch (_error) {
          // Ignore network instrumentation errors.
        }

        return response;
      });
    };

    window.__cafTrackingFetchPatched = true;
  }

  function bindCheckoutHooks() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        var checkoutButton = target.closest('[data-cart-checkout-button], button[name="checkout"], input[name="checkout"]');
        if (!checkoutButton) return;

        trackBeginCheckout();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart') === -1 && action.indexOf('/checkout') === -1) return;

        if (!form.querySelector('[data-cart-checkout-button], [name="checkout"]')) return;

        trackBeginCheckout();
      },
      true
    );
  }

  function primeCartSnapshot() {
    var path = window.location.pathname || '';
    if (path !== '/cart' && !path.startsWith('/cart/')) return;
    if (typeof window.fetch !== 'function') return;

    window
      .fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
      })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart === 'object' && Array.isArray(cart.items)) {
          cartSnapshot = cart;
        }
      })
      .catch(function () {
        // Ignore cart priming errors.
      });
  }

  patchXhr();
  patchFetch();
  bindCheckoutHooks();
  primeCartSnapshot();
})();
